<template>
  <div id="box">
    <dv-full-screen-container>
      <div class="font-Change">
        <div class="font-chinese" @click="changeChinese()">简体中文</div>
        <div class="font-english"  @click="changeEnglish()">English</div>
      </div>
      <div class="box-card">
        <el-card>
          <el-form :model="form" :rules="rules" @keydown.enter.native="onSubmit" class="login-box" label-width="25%"
                   ref="login">
            <div class="title">{{$t("cloudPlatform")}}</div>
            <el-input prefix-icon="el-icon-s-custom" :placeholder= "$t('userName')" v-model="form.email" class="inputEmail"></el-input>
            <el-input prefix-icon="el-icon-lock" :placeholder="$t('password')"  type="password" v-model="form.password" class="inputPwd"></el-input>
            <el-button @click="onSubmit" type="primary" round class="loginBtn">{{$t("login")}}</el-button>
          </el-form>
        </el-card>
      </div>


<!--      <el-card>-->
<!--        <el-form :model="form" :rules="rules" @keydown.enter.native="onSubmit" class="login-box" label-width="25%"-->
<!--                 ref="login">-->
<!--          <p style="font-size: 30px;text-align:center; color: #ffffff">云&#12288平&#12288台</p>-->
<!--          <el-form-item label="账号" prop="email">-->
<!--            <el-input placeholder="用户名(电子邮箱)" v-model="form.email"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="密码" prop="password">-->
<!--            <el-input placeholder="密码" type="password" v-model="form.password"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item style="margin-left: 20%">-->
<!--            <el-button @click="onSubmit" type="primary">登录</el-button>-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--      </el-card>-->

    </dv-full-screen-container>
  </div>

</template>


<script>
  import router from "../router/index"
  import {getAuth, userLogin} from "../untils/api/login";

  export default {
    name: "Login",
    data() {
      return {
        form: {
          email: "",
          password: "",
        },

        // 表单验证，需要在 el-form-item 元素中增加 prop 属性
        rules: {
          email: [
            {required: true, message: this.$t('userError'), trigger: "blur"},
          ],
          password: [
            {required: true, message: this.$t('passwordError'), trigger: "blur"},
          ],
        },
        windowHeight: 0,
        windowWidth: 0
      };
    },
    mounted() {
      let url = window.location.href;
      localStorage.setItem('deviceName', null);
      if((url.indexOf("?user") != -1) && (url.indexOf("&pwd") != -1)) {
        let user = decodeURIComponent((new RegExp('[?|&]'+ 'user'+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
        let device = decodeURIComponent((new RegExp('[?|&]'+ 'pwd'+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;

        let userJson = JSON.parse(this.$commonFun.deciphering(user));
        let deviceJson = this.$commonFun.deciphering(device)
        localStorage.setItem('deviceName', device);

        this.form.email = userJson.username;
        this.form.password = userJson.password;
        this.onSubmit();
        // console.log("22222222", userJson, deviceJson)
      } else if(localStorage.getItem('login') !== null) {
        let paramJson = JSON.parse(this.$commonFun.deciphering(localStorage.getItem('login')));
        this.form.email = paramJson.username;
        this.form.password = paramJson.password;
        this.onSubmit();
      }

      if(localStorage.getItem('locale') === null){
        this.$i18n.locale = 'zh-CN';
        localStorage.setItem('locale', 'zh-CN');
      }


      // let paramJsom =  JSON.parse(localStorage.getItem('login'));
      // if(JSON.stringify(paramJsom) !== 'null'){
      //   this.form.email = paramJsom.username;
      //   this.form.password = paramJsom.password;
      //   this.onSubmit();
      // }

    },
    methods: {
      changeChinese() {
        // this.$i18n.locale = 'zh-CN';
        localStorage.setItem('locale', 'zh-CN');
        window.location.reload();
      },

      changeEnglish() {
        // this.$i18n.locale = 'en-US';
        localStorage.setItem('locale', 'en-US');
        window.location.reload();
      },
      /**
       * 登录
       */
      onSubmit() {
        // console.log(this.form.email);
        // console.log(this.form.password);
        this.windowHeight = document.documentElement.clientHeight;
        this.windowWidth = document.documentElement.clientWidth;
        //设置参数
        let param = {"username": this.form.email, "password": this.form.password};
        //访问登录api
        userLogin(param).then(response => {
          //localStorage.setItem('token', response.token);
          localStorage.setItem('token', this.$commonFun.encryption(response.token))
          localStorage.setItem('login',null);
          // localStorage.setItem('login',JSON.stringify(param));
          localStorage.setItem('login', this.$commonFun.encryption(JSON.stringify(param)));
          //console.log("token", response.token);
          // router.push('/home');
          this.getAuthority()
        }).catch(error => {
          console.log("error", error);
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t('loginError')
          });
        })
      },

      /**
       * 获取用户信息
       */
      getAuthority() {
        getAuth().then(response => {
          //localStorage.setItem('authority', response.authority);
          localStorage.setItem('authority', this.$commonFun.encryption(response.authority));
          //localStorage.setItem('customerId', response.customerId.id);
          localStorage.setItem('customerId', this.$commonFun.encryption(response.customerId.id));
          //localStorage.setItem('email', response.email);
          localStorage.setItem('email', this.$commonFun.encryption(response.email));
          if (response.authority === 'SYS_ADMIN') {
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t('loginError')
            });
          } else {
            if(this.windowWidth < 500) {
              router.push({
                name: 'mobileDetailed',
                path: '/mobileDetailed',
                params: {authority: response.authority, customerId: response.customerId.id}
              });
            } else {
              router.push({
                name: 'home',
                path: '/home',
                params: {authority: response.authority, customerId: response.customerId.id, email: response.email}
              });
              //console.log("authority", response.authority, response.customerId.id, response.email);
            }
          }

        }).catch(error => {
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t('loginError')
          });
        })
      },
    },

  };
</script>
<style lang="less">
  @import "less/login.less";
</style>



// WEBPACK FOOTER //
// src/components/Login.vue